export const XBIT_RELAY_DEPOSITS_PERMISSION_RESOURCE = 'xbit-relay:deposits';
export const XBIT_RELAY_DEPOSITS_EXPORT_ACTION = 'export';
export const DEFAULT_DEPOSITS_PROVIDER = 'INTERNAL_PERPETUAL';

export const DEPOSIT_STATUSES = [
  'PENDING',
  'PROCESSING',
  'CONFIRMING',
  'SUCCESS',
  'FAILED',
] as const;
